import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalculator = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Group_377",
		"data-name": "Group 377",
		transform: "translate(-3 -3)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_377-2",
			"data-name": "Group 377",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_91",
					"data-name": "Path 91",
					d: "M19,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Zm0,16H5V5H19Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_134",
					"data-name": "Rectangle 134",
					width: 5,
					height: 1.5,
					transform: "translate(6.25 7.72)",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_135",
					"data-name": "Rectangle 135",
					width: 5,
					height: 1.5,
					transform: "translate(13 15.75)",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_136",
					"data-name": "Rectangle 136",
					width: 5,
					height: 1.5,
					transform: "translate(13 13.25)",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_92",
					"data-name": "Path 92",
					d: "M8,18H9.5V16h2V14.5h-2v-2H8v2H6V16H8Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_93",
					"data-name": "Path 93",
					d: "M14.09,10.95,15.5,9.54l1.41,1.41,1.06-1.06L16.56,8.47l1.41-1.41L16.91,6,15.5,7.41,14.09,6,13.03,7.06l1.41,1.41L13.03,9.89Z",
					fill: "currentColor"
				})
			]
		})
	})]
});
const ForwardRef = forwardRef(SvgCalculator);
export default ForwardRef;
